import { render, staticRenderFns } from "./RankingRidersTable.vue?vue&type=template&id=501c8e2d&scoped=true&"
import script from "./RankingRidersTable.vue?vue&type=script&lang=js&"
export * from "./RankingRidersTable.vue?vue&type=script&lang=js&"
import style0 from "./RankingRidersTable.vue?vue&type=style&index=0&id=501c8e2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501c8e2d",
  null
  
)

export default component.exports